/* Policy page reveal enhancement. All policy text remains visible without JavaScript. */
(() => {
  'use strict';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealAll = (targets) => targets.forEach((target) => target.classList.add('is-visible'));
  const init = (scope = document) => scope.querySelectorAll('[data-policy-page]').forEach((root) => {
    if (root.dataset.policyInitialized === 'true') return;
    root.dataset.policyInitialized = 'true';

    const targets = [...root.querySelectorAll('[data-policy-reveal]')];
    if (root.dataset.policyAnimations === 'false' || reducedMotion() || !('IntersectionObserver' in window)) {
      revealAll(targets);
      return;
    }

    try {
      root.dataset.policyReady = 'true';
      const observer = new IntersectionObserver((entries, instance) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        }
      }), { threshold: .12 });
      targets.forEach((target) => observer.observe(target));
    } catch (error) {
      delete root.dataset.policyReady;
      revealAll(targets);
    }
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init();
})();
